<script setup lang="ts">
import BaseSvg from './BaseSvg.vue';
</script>

<template>
  <BaseSvg class="icon icon-hamburger" width="17" height="17" fill="none" viewBox="0 0 17 17">
    <defs>
      <path
        id="a"
        stroke="#33E672"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.48"
        d="M.74-.74h19.37"
      />
    </defs>
    <use
      xlink:href="#a"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.48"
      transform="scale(-.99444 -1.00553) rotate(45 10.53 -28.23)"
    />
    <use
      xlink:href="#a"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.48"
      transform="scale(-.99444 -1.00553) rotate(-45 -9.03 18.5)"
    />
  </BaseSvg>
</template>
